///<reference path="../enterp-atlas/enterp-atlas.component.ts"/>
import {AfterViewInit, Component, OnInit} from '@angular/core';
import {HttpCommonService} from "../../services/http-common.service";
import {ActivatedRoute} from "@angular/router";
import {EnterpAtlasService} from "../../services/enterp-atlas.service";
import '../../../assets/plugins/d3/d3.min.js';
declare var d3: any;

/**
 * 企业图谱
 */
@Component({
  selector: 'app-enterp-map',
  templateUrl: './enterp-map.component.html',
  styleUrls: ['./enterp-map.component.css']
})
export class EnterpMapComponent implements OnInit, AfterViewInit {

  // tree: any;
  // svg: any;
  // linkContainer: any;
  // container: any;
  // zoom: any;
  // nodes: any;
  // links: any;
  rootData: any;//返回值
  //传递的参数 企业ID
  companyId: string;

  constructor(private routerInfo: ActivatedRoute, private httpService: HttpCommonService,
              private enterpAtlasService: EnterpAtlasService) {
    this.companyId = routerInfo.snapshot.queryParams['companyId'];
    // this.companyId = "00001e0dc8082237c287be3db76761ca";
  }

  ngOnInit() {
    this.getMapData();
  }

  //获取图谱数据
  getMapData() {
    /*this.httpService.get("/enterprise/detail/xhsRest/enterMap/getTuPuDatas",
      {companyId: this.companyId}).subscribe(result =>{
        // console.log(result);
      this.rootData = result.data;
    });*/
  }

  ngAfterViewInit() {
    var thiss = this;
    var tree;
    var svg;
    var linkContainer;
    var nodes;
    var links;
    var container;
    var zoom;
    var resultData ;
    $(function(){
      if (thiss.companyId) {
        $("#enterMap").html('');
        thiss.httpService.get("/enterprise/detail/xhsRest/baseMsg/getCompanyInfo",
          {"companyId": thiss.companyId}).subscribe(data => {
          if(data.data.returnData!=null){
            let companyName = data.data.returnData[0].name;
            thiss.httpService.get("/enterprise/detail/xhsRest/enterMap/getTreeCompanyMapByQcc",
              {keyword: companyName}).subscribe(result =>{
              resultData = result.data;
              initMap(result.data);
            });
          }
        });
      }
    });
    function initMap(resultData) {
      traverseTreeId(resultData),
        draw(resultData);
    }
    //遍历树
    function traverseTreeId(node){
      var id = 1;
      trId(node);
      function trId(node){
        if(!node.id){
          node.id = id;
          id++;
        }
        if(node.children){
          for(var i=0; i<node.children.length; i++){
            trId(node.children[i]);
          }
        }
      }
    }
    //绘画图谱
    function draw(root){
      tree = d3.layout.cluster().size([360, 600]).separation(function(a, b) { return (a.parent == b.parent ? 2:3) / a.depth; });
      $("#enterMap").empty();
      svg = d3.select("#enterMap").append("svg").attr("xmlns","http://www.w3.org/2000/svg");
      svg.empty();
      d3.select('svg').attr('width',$('#enterMap').width());
      d3.select('svg').attr('height',$('#enterMap').height());
      container = svg.append("g");
      linkContainer = container.append("g");
      zoom = d3.behavior.zoom().scaleExtent([0.4, 2]).on("zoom", zoomed);
      svg.call(zoom);
      initLocation();
      function zoomed() {
        container.attr("transform", "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")");
      }
      function initLocation(){
        zoom.translate([svg.attr('width')/2,svg.attr('height')/2]);
        zoom.scale(0.8);
        container.attr("transform", "translate("+zoom.translate()+")scale("+zoom.scale()+")");
      }
      drawTree(root);
    }
    //处理树
    function drawTree(data) {
      var diagonal = d3.svg.diagonal.radial().projection(function(d) { return [d.y, d.x / 180 * Math.PI]; });
      data.x0=0;
      data.y0=0;
      nodes = tree.nodes(resultData);
      links = tree.links(nodes);
      var pathLength = 150;
      if(nodes.length>100){
        pathLength = 200;
      }
      nodes.forEach(function(d) {
        if(d.depth>2){
          d.y = d.depth * (d.depth/2) * 150;
        }else{
          d.y = d.depth * pathLength;
        }
      });
      var linkUpdate = linkContainer.selectAll(".link").data(links,function(d){ return d.target.id; });
      var linkEnter = linkUpdate.enter();
      var linkExit = linkUpdate.exit();
      linkEnter.append("path").attr("class", "link").attr("d", function(d) {
        var o = {x: data.x0, y: data.y0};
        return diagonal({source: o, target: o});
      }).transition().duration(500).attr("d", diagonal);
      linkUpdate.attr("stroke", function (d) {
        if(d.source.Category==2|| d.target.Category==2){
          return "#7ec56a";
        }
        if(d.source.Category==3|| d.target.Category==3){
          return "#728dc9";
        }
        if(d.source.Category==4|| d.target.Category==4){
          return "#65d289";
        }
        if(d.source.Category==5|| d.target.Category==5){
          return "#a496c7";
        }
        if(d.source.Category==6|| d.target.Category==6){
          return "#ee7698";
        }
        return "#f35151";
      }).transition().duration(500).attr("d", diagonal)
        .attr("style", "fill: none; stroke-opacity: 1; stroke: #9ecae1; stroke-width: 1px;");
      linkExit.transition().duration(500).attr("d", function(d) {
        var o = {x: data.x, y: data.y};
        return diagonal({source: o, target: o});
      }).remove();
      var nodeUpdate = container.selectAll(".node").data(nodes,function(d){ return d.id; });
      var nodeEnter = nodeUpdate.enter();
      var nodeExit = nodeUpdate.exit();
      var enterNodes = nodeEnter.append("g").attr("class", function(d) { return "node"; })
        .attr("transform", function(d) { return "translate(" + project(data.x0, data.y0) + ")"; });
      enterNodes.append("circle").attr("r", 0).attr("fill",function(d){
        if(d.Category==1){
          return "#40bfd5";
        }
        if(d.Category==2){
          return "#7ec56a";
        }
        if(d.Category==3){
          return "#728dc9";
        }
        if(d.Category==4){
          return "#65d289";
        }
        if(d.Category==5){
          return "#a496c7";
        }
        if(d.Category==6){
          return "#ee7698";
        }
        return "#40bfd5";
      }).attr("stroke", function (d) {
        if(d.depth==0){
          return "#40bfd5";
        }
        if(d.depth==1){
          if(d.Category==1){
            return "#40bfd5";
          }
          if(d.Category==2){
            return "#7ec56a";
          }
          if(d.Category==3){
            return "#728dc9";
          }
          if(d.Category==4){
            return "#65d289";
          }
          if(d.Category==5){
            return "#a496c7";
          }
          if(d.Category==6){
            return "#ee7698";
          }
        }
        return null;
      }).attr("stroke-opacity",0.5).attr("stroke-width", function (d) {
        if(d.depth==0){
          return 10;
        }
        if(d.depth==1){
          return 6;
        }
        return 0;
      }).on("click", function (d) {
        if(d.depth>0){
          toggle(d);
          drawTree(d);
        }
      });
      enterNodes.append("path").attr("d", function (d) {
        if(d.depth>0 && d._children){
          return "M-6 -1 H-1 V-6 H1 V-1 H6 V1 H1 V6 H-1 V1 H-6 Z";
        }else if(d.depth>0 && d.children){
          return "M-6 -1 H6 V1 H-6 Z";
        }
      }).attr("fill","#ffffff").attr("stroke","#ffffff").attr("stroke-width","0.2").on("click", function (d) {
        if(d.depth>0){
          toggle(d);
          drawTree(d);
        }
      });
      enterNodes.append("text").attr("dy", function(d){
        if(d.depth==0){
          return "-1.5em";
        }
        return "0.31em";
      }).attr("x", function(d) {
        if(d.depth==0){
          return d.name.length*8;
        }
        return d.x < 180 ? 15 : -15;
      }).text(function(d) { return d.name; }).style("text-anchor", function(d) {
        if(d.depth==0){
          return "end";
        }
        return d.x < 180 ? "start" : "end";
      }).style("fill-opacity", 0).attr("transform", function(d) {
        if(d.depth>0){
          return "rotate(" + (d.x < 180 ? d.x - 90 : d.x + 90) + ")";
        }else{
          return "rotate(0)";
        }
      }).style("font-size", function (d) {
        if(d.depth==0){
          return "16px";
        }
        return "14px";
      }).attr("fill", function (d) {
        if(d.depth==0){
          return "#2c91e8";
        }
        if(d.depth==1){
          if(d.Category==2){
            return "#2db092";
          }
          if(d.Category==3){
            return "#3d4cd4";
          }
        }
        return "#333";
      });
      var updateNodes = nodeUpdate.transition().duration(500)
        .attr("transform", function(d) { return "translate(" + project(d.x, d.y) + ")"; });
      updateNodes.select("text").style("fill-opacity", 1).attr("transform", function(d) {
        if(d.depth>0){
          return "rotate(" + (d.x < 180 ? d.x - 90 : d.x + 90) + ")";
        }else{
          return "rotate(0)";
        }
      }).attr("x", function(d) {
        if(d.depth==0){
          return d.name.length*8;
        }
        return d.x < 180 ? 15 : -15;
      }).attr("fill", function (d) {
        if(d.depth==0){
          return "#2c91e8";
        }
        if(d.depth==1){
          if(d.Category==2){
            return "#2db092";
          }
          if(d.Category==3){
            return "#3d4cd4";
          }
        }
        return "#333";
      }).style("text-anchor", function(d) {
        if(d.depth==0){
          return "end";
        }
        return d.x < 180 ? "start" : "end";
      });
      updateNodes.select("circle").attr("r", function (d) {
        if(d.depth==0){
          return 12;
        }
        if(d.depth==1){
          return 10;
        }
        return 9;
      });
      updateNodes.select("path").attr("d", function (d) {
        if(d.depth>0 && d._children){
          return "M-6 -1 H-1 V-6 H1 V-1 H6 V1 H1 V6 H-1 V1 H-6 Z";
        }else if(d.depth>0 && d.children){
          return "M-6 -1 H6 V1 H-6 Z";
        }
      });
      var exitNodes=nodeExit.transition().duration(500)
        .attr("transform", function(d) { return "translate(" + project(data.x, data.y) + ")"; }).remove();
      exitNodes.select("circle").attr("r", 0);
      exitNodes.select("text").style("fill-opacity", 0);
      nodes.forEach(function(d) {
        d.x0 = d.x;
        d.y0 = d.y;
      });
    }
    function toggle(d){
      if (d.children) {
        d._children = d.children;
        d.children = null;
      } else {
        d.children = d._children;
        d._children = null;
      }
    }
    function project(x, y) {
      var angle = (x - 90) / 180 * Math.PI, radius = y;
      return [radius * Math.cos(angle), radius * Math.sin(angle)];
    }
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/enterp-map/enterp-map.component.ts